import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import { ClassifierMappingBreadcrumbsData } from './ClassifierMappingBreadcrumbs.types';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './ClassifierMappings.translations.json';
import { ClassifierMappingDetail } from './ClassifierMappingDetail';
import { ClassifierMappingForm } from './ClassifierMappingForm';
import { ClassifierMappingDirectory } from './ClassifierMappingDirectory';
import { ClassifierMappingEdit } from './ClassifierMappingEdit';
import { NotFound } from '../NotFound';

export const { addTranslations, useTranslation, Translation } = i18nNsFactory(
  'classifier-mappings-page'
);
addTranslations(translations);

export const CLASSIFIER_MAPPING_ROUTES = [
  {
    path: path.classifierMappingDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.classifier-mappings')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <ClassifierMappingDirectory />,
      },
      {
        path: path.classifierMappingCreate,
        element: <ClassifierMappingForm mode="create" />,
        renderBreadcrumb: () => (
          <Translation>
            {(t) => t('breadcrumb.classifier-mapping-create')}
          </Translation>
        ),
      },
      {
        path: path.classifierMappingView,
        element: <ClassifierMappingDetail />,
        renderBreadcrumb: (data?: ClassifierMappingBreadcrumbsData) =>
          data?.classifierMapping ? (
            `${data.classifierMapping.code} - ${data.classifierMapping.name}`
          ) : (
            <Translation>
              {(t) => t('breadcrumb.classifier-mapping-detail')}
            </Translation>
          ),
      },
      {
        path: path.classifierMappingEdit,
        element: <ClassifierMappingEdit mode="edit" />,
        renderBreadcrumb: () => (
          <Translation>
            {(t) => t('breadcrumb.classifier-mapping-edit')}
          </Translation>
        ),
      },
      {
        path: path.classifierMappingClone,
        element: <ClassifierMappingEdit mode="clone" />,
        renderBreadcrumb: () => (
          <Translation>
            {(t) => t('breadcrumb.classifier-mapping-edit')}
          </Translation>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const ClassifierMappings: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, CLASSIFIER_MAPPING_ROUTES));
